import React, { useCallback } from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../localization/messages";
import { MessageBrokerUtils, NavigationUtils } from "../../../utils";
import {
  NativeSelectors,
  UISelectors,
  UserContextSelectors
} from "../../../redux/selectors";
import { useSelector } from "react-redux";
import { Channel, Topic } from "../../../constants";
import { AppFeatures } from "../../../constants/featureFlags";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../../redux/action-creators";
import { performAction } from "../../../utils/actionUtils";
import { useFeature } from "../../../hooks/useFeature";

const CasinoBottomBarNavigationItem = () => {
  const dispatch = useDispatch();
  const links = useSelector(UISelectors.links);
  const isNativeCISEnabled = useSelector(
    NativeSelectors.isCasinoInSportEnabled
  );
  const isNative = useSelector(UserContextSelectors.isNative);
  const isCISFeatureActive = useFeature(AppFeatures.CASINO_IN_SPORT);

  const openCasino = useCallback((data = {}) => {
    MessageBrokerUtils.publish({
      channel: Channel.CROSS_SELL,
      topic: Topic.CTA_CasinoClient_Open,
      headers: { publisher: "UAA" },
      data: data
    });
  }, []);

  const onCasinoClick = useCallback(
    (event, data) => {
      event.preventDefault();
      if (isNativeCISEnabled && isCISFeatureActive) {
        dispatch(MenuActionCreators.hideHamburgerMenu());
        performAction("openCIS");
      } else if (isNative && links.casinoNativeUrl) {
        NavigationUtils.openExternalUrlWithSCut(links.casinoNativeUrl);
      } else {
        openCasino(data);
      }
    },
    [
      dispatch,
      isCISFeatureActive,
      isNative,
      isNativeCISEnabled,
      links.casinoNativeUrl,
      openCasino
    ]
  );

  return (
    <BottomBarNavigationItem
      onClick={onCasinoClick}
      iconColor={"white"}
      iconLabel={"dice"}
      dataTestId={"bottom-navigation-casino"}
      googleAnalyticsLabel={"cross-casino"}
    >
      <FormattedMessage {...LocalizationMessages.bottomNavigationCasino} />
    </BottomBarNavigationItem>
  );
};

export default React.memo(CasinoBottomBarNavigationItem);

CasinoBottomBarNavigationItem.propTypes = {};
